// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1YGjI","icon":"SortAdornment_icon__1Mi6J","up":"SortAdornment_up__2rAVL","down":"SortAdornment_down__1UpoH","active":"SortAdornment_active__1iuXE"};